export const headings =  {
    'cladding' : 'Roof Cladding',
    'rafter' : 'Batten-to-Rafter Connections',
    'ridgeline' : 'Ridgeline',
    'wall' : 'Roof to Wall Connections',
    'floor' : 'Wall to Floor Tie-Down',
    'pier' : 'Floor to Pier Connections',
    'internal' : 'Internal Roof Connections',
}
